// extracted by mini-css-extract-plugin
module.exports = {"carouselItemWrapper":"CarouselItem_carouselItemWrapper__xoxF0"};